module.exports = __webpack_public_path__ + "img/DesktopAssessment.f9d9c242.jpg";